import { uniqBy } from 'ramda';

/** Условие конца дерева вопросов */
var isLastStep = function isLastStep(children) {
  return !children[0];
};
/**
 * Хелпер возвращает высоту поддерева опросника - длину самой длинной ветви
 * Если передать не начало опросника - прошедшие шаги учтены не будут.
 * */


export var getQuizMaxHeight = function getQuizMaxHeight(params) {
  var nextStep = params.currentStep.nextStep,
      scheme = params.scheme;
  /** Набор уникальных "листьев" для текущего шага */

  var _children = nextStep.reduce(function (acc, obj) {
    acc.push(obj.nextStepCode);
    return acc;
  }, []);

  var children = uniqBy(function (step) {
    return step;
  }, _children);
  /** Высота последнего шага в дереве равна 1 - условие окончания рекурсии */

  if (isLastStep(children)) {
    return 0;
  }
  /** Высота поддерева от текущего шага и вглубь */


  var stepHeight = children.reduce(function (acc, currentStepCode) {
    var currentStep = scheme[currentStepCode];
    var subtreeHeight = currentStep ? getQuizMaxHeight({
      currentStep: currentStep,
      scheme: scheme
    }) : 0;
    return Math.max(acc, subtreeHeight);
  }, 0);
  return stepHeight + 1;
};